























































































































































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

@Component
export default class AxMessageModal extends Mixins(AxPage) {
  @Ref()
  modal!: HTMLDialogElement;

  state = {
    title: '오류',
    text: '메시지 테스트',
    buttons: ['버튼'],

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    event: (n: number) => {}
  };

  async created() {
    setTimeout(() => {
      this.modal.addEventListener('cancel', e => {
        e.preventDefault();
        this.state.event(-1);
      });
    }, 0);
  }

  async confirm(title: string, text: string, buttons?: string[]) {
    await this.showModal(title, text, buttons);

    return new Promise(resolve => {
      this.state.event = async (n: number) => {
        await this.closeModal();
        resolve(n);
      };
    });
  }

  async error(title: string, text: string) {
    await this.showModal(title, text, ['확인']);

    return new Promise(resolve => {
      this.state.event = async (n: number) => {
        await this.closeModal();
        resolve(n);
      };
    });
  }

  cancel(e: HTMLElementEvent<HTMLDivElement>) {
    if (
      e.target.classList.contains('container') &&
      !this.modal.classList.contains('show') &&
      !this.modal.classList.contains('hide')
    ) {
      this.state.event(-1);
    }
  }

  async sleep(ms: number) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  timeout(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async showModal(title: string, text: string, buttons?: string[]) {
    await this.timeout(0);

    while (1) {
      if (this.modal.open) {
        await this.closeModal();
        await this.sleep(100);
      } else {
        break;
      }
    }

    this.state.title = title;
    this.state.text = text;
    this.state.buttons = buttons || ['확인', '취소'];

    return new Promise(resolve => {
      this.modal.classList.add('show');
      this.modal.closest('.ax-message-modal')?.setAttribute('open', '');

      const animationEnd = async () => {
        await this.sleep(300);
        this.modal.classList.remove('show');
        this.modal.removeEventListener('webkitAnimationEnd', animationEnd, false);
      };

      this.modal.addEventListener('webkitAnimationEnd', animationEnd, false);
      this.modal.showModal();
      resolve(true);
    });
  }

  async closeModal() {
    return new Promise(resolve => {
      this.modal.classList.add('hide');
      this.modal.closest('.ax-message-modal')?.removeAttribute('open');

      const animationEnd = () => {
        this.modal.classList.remove('hide');
        this.modal.close();
        this.modal.removeEventListener('webkitAnimationEnd', animationEnd, false);
      };

      this.modal.addEventListener('webkitAnimationEnd', animationEnd, false);
      resolve(true);
    });
  }
}
